export const JOB_EXPERIENCE_LEVELS: string[] = [
	'Fresher (0 years)',
	'1 - 3 years',
	'3 - 5 years',
	'5 - 7 years',
	'7 - 9 years',
	'10+ years'
];
